module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0116.jpg?v=ab183aa8";